import React, { useState, useEffect } from 'react';
import { Row, Col, Table, Input, Tag, Button } from 'antd';
import TablePager from 'shared_components/table_pager';
import { PlusOutlined } from '@ant-design/icons';
import { GLOBAL_TABLE_PAGE_SIZE, GLOBAL_TABLE_SIZE, } from 'global_config/constant-global';
import { fetchListOfPathologists, fetchPathologist } from 'services/settings/pathologists';
import PathologistForm from './pathologists_form';
import SearchPager from 'shared_components/search_pager';
import './search_table.css';
import moment from 'moment';
import { showMessage } from 'services/settings/message';
import DownloadCSV from 'shared_components/download_csv';

const { Search } = Input;

const PathologistSearchTable = () => {
    const [data, setData] = useState([]);
    const [tablePageSize, setTablePageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
    const [tableSize, setTableSize] = useState(GLOBAL_TABLE_SIZE);
    const [showDrawer, setShowDrawer] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataRef, setDataRef] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);
        
    const fetchData = async (filters = null) =>{
        let filtered;
        const pathologists =  await fetchListOfPathologists();

        if(filters !== null){
            if(filters.includes(',')){
                const [lastName, firstName] = filters.split(',').map(name => name.trim().toLowerCase());
                filtered = pathologists.slice().filter(item => {
                    const itemLastName = item.pathologistLastName ? item.pathologistLastName.toLowerCase() : '';
                    const itemFirstName = item.pathologistFirstName ? item.pathologistFirstName.toLowerCase() : '';
                    return (
                        containsString(itemLastName, lastName) && containsString(itemFirstName, firstName)
                    );
                });
                setData(filtered);
            }else{
                filtered = pathologists.slice().filter(item => {
                    const { pathologistLastName, pathologistFirstName } = item;

                    return (
                        containsString(pathologistLastName, filters) ||
                        containsString(pathologistFirstName, filters)
                    );
                });
                // console.log('filtered =>', filtered);
                // Show "No result found" message if no results
                if (filtered.length === 0 && filters.trim() !== '') {
                    showMessage('M0001');
                }
                    setData(filtered);

            }

        }else{
            setData(pathologists);
        }

        setDataRef(pathologists);
    }

    const columns = [
        {
		    title: 'ID',
		    dataIndex: 'pathologistID',
		    key: 'pathologistID',
		    width: 50
        },
        {
		    title: 'First Name',
		    dataIndex: 'pathologistFirstName',
		    key: 'pathologistFirstName',
		    width: 150,
		    // sorter: (a, b) => a.pathologistFirstName.localeCompare(b.pathologistFirstName),
		    sorter: (a, b) => {
                const prev = String(a.pathologistFirstName || '');
                const next = String(b.pathologistFirstName || '');
                return prev.localeCompare(next);
            }
        },
        {
		    title: 'Middle Name',
		    dataIndex: 'pathologistMiddleName',
		    key: 'pathologistMiddleName',
		    width: 150,
		    sorter: (a, b) => {
                const prev = String(a.pathologistMiddleName || '');
                const next = String(b.pathologistMiddleName || '');
                return prev.localeCompare(next);
            }
        },
        {
		    title: 'Last Name',
		    dataIndex: 'pathologistLastName',
		    key: 'pathologistLastName',
		    width: 150,
		    // sorter: (a, b) => a.pathologistLastName.localeCompare(b.pathologistLastName),
		    sorter: (a, b) => {
                const prev = String(a.pathologistLastName || '');
                const next = String(b.pathologistLastName || '');
                return prev.localeCompare(next);
            }
        },
        {
		    title: 'DEGREE',
		    dataIndex: 'pathologistDegree',
		    key: 'pathologistDegree',
		    width: 150,
		    sorter: (a, b) => {
                const prev = String(a.pathologistDegree || '');
                const next = String(b.pathologistDegree || '');
                return prev.localeCompare(next);
            }
        },
        {
		    title: 'LICENSE NO.',
		    dataIndex: 'pathologistLicenseNo',
		    key: 'pathologistLicenseNo',
		    width: 150,
		    sorter: (a, b) => {
                const prev = String(a.pathologistLicenseNo || '');
                const next = String(b.pathologistLicenseNo || '');
                return prev.localeCompare(next);
            }
        },
        {
		    title: 'VALIDITY',
		    dataIndex: 'pathologistValidity',
		    key: 'pathologistValidity',
		    width: 150,
		    sorter: (a, b) => {
                const pa = a.pathologistValidity ? moment(a.pathologistValidity).valueOf() : 0;
                const pb = b.pathologistValidity ? moment(b.pathologistValidity).valueOf() : 0;
                return pa - pb;
            },
            render: date => (
                date ? moment(date).format('MM-DD-YYYY') : ''
            )
        },
        { 
            title: 'STATUS',
            dataIndex: 'isActive',
            width: 100,
            render: active => (
                <Tag color={active === 0 ? "red" : "green"}>
                    {active === 0 ? 'INACTIVE' : 'ACTIVE'}
                </Tag>
            )
        }
    ];

    const displayDrawerUpdate = async (record) => {
        console.log('Record to update =>', record);
        setShowDrawer(true);
        if(record !== null){
            let selectedRecord = record;
            selectedRecord.pathologistValidity = record.pathologistValidity ? moment(record.pathologistValidity) : undefined;
            setSelectedRecord(selectedRecord);
        }
    }

    const closeDrawer = async () => {
        console.log('test =>', selectedRecord);
        setShowDrawer(false);
        setSelectedRecord(null);
        onSearch(searchText);
        await fetchData();
    }

    const onSearch = async (value) => {
        // console.log('Search Value: =>', value);
        // console.log('data =>', data);
		
        const searchedVal = value.toLowerCase();
        await fetchData(searchedVal);
    }

    const onChangeSearch = (e) => {
        // console.log('Search Input Changed: =>', e.target.value);
        const { value } = e.target;

        if(value === ''){
            fetchData();
        }
    }

    const addPathologist = () => {
        setSelectedRecord(null);
        setShowDrawer(true);
    }

    const onPaginationChange = (page, pageSize) => {
        console.log('page =>', page);
        console.log('pageSize =>', pageSize);
        setCurrentPage(page);
        setTablePageSize(pageSize);
    }

	const containsString = (searchFrom, searchedVal) => {
		return (['', null, undefined].includes(searchFrom)) ? false : searchFrom.toString().toLowerCase().includes(searchedVal);
	}

    return (
        <div>
            <div>
                <Row>
                    <Col span={12}>
							<p style={{ margin: 0 }}>SEARCH</p>
                            <Search
								allowClear
								onSearch={value => onSearch(value)}
								onChange={onChangeSearch}                                
								style={{ width: 200 }}
                                placeholder='LAST NAME, FIRST NAME'
								className="pathologist-search-input"
							/>
                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: 'end', marginTop: 24}}>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <DownloadCSV
                                confirmRequired={true}
                                isLookupTable={true}
                                filename="pathologists"
                                confirmDetails={{
                                    title: 'PATHOLOGIST',
                                    section: 'PATHOLOGIST',
                                    count: (dataRef || []).length,
                                }}
                                data={dataRef}
                                disabled={dataRef.length === 0}
                                columns={[
                                    { title: 'ID', dataIndex: 'pathologistID' },
                                    { title: 'First Name', dataIndex: 'pathologistFirstName' },
                                    { title: 'Middle Name', dataIndex: 'pathologistMiddleName' },
                                    { title: 'Last Name', dataIndex: 'pathologistLastName' },
                                    { title: 'DEGREE', dataIndex: 'pathologistDegree' },
                                    { title: 'LICENSE NO.', dataIndex: 'pathologistLicenseNo' },
                                    { 
                                        title: 'VALIDITY', 
                                        dataIndex: 'pathologistValidity',
                                        render: date => (date ? moment(date).format('MM-DD-YYYY') : '')
                                    },
                                    { 
                                        title: 'STATUS', 
                                        dataIndex: 'isActive',
                                        render: active => (active === 0 ? 'INACTIVE' : 'ACTIVE')
                                    }
                                ]}
                            />
                            <Button type='primary' shape='round' onClick={addPathologist}>
                                <PlusOutlined /> ADD PATHOLOGIST
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <SearchPager 
                                pageSize={tablePageSize}
                                pageTotal={data.length}
                                handleChangeSize={setTablePageSize}
                                currentPage={currentPage}
                        />
                    </Col>
                </Row>
            </div>
            <div style={{ marginTop: 24}}>
                <Table
                    columns={columns}
                    dataSource={data}
                    pagination={{ pageSize: tablePageSize, onChange: onPaginationChange, current: currentPage }}
                    rowKey={record => record.pathologistID}
                    onRow={(record) => {
                        return {
                            onDoubleClick: ()=>{displayDrawerUpdate(record)}
                            }    
                        }
                    }
                />
            </div>
            <PathologistForm 
                visible={showDrawer}
                onClose={closeDrawer}
                record={selectedRecord}
                initialValues={selectedRecord}
                closeDrawer={closeDrawer}
            />
        </div>
    );
};

export default PathologistSearchTable;